import React from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputGroupAddon, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { parseLocaleNumber } from '../../../../utility/util/util.service';

const KcalField = ({ object, ...props }) => {
  const locale = useIntl()?.locale;

  const kcal = useIntl().formatNumber(object?.kcal || 0);

  return (
    <AvGroup className="form-label-group input-group input-group-merge">
      <FormattedMessage id="kcalLabel">
        {(placeholder) => (
          <AvInput
            id={object?.id}
            type="text"
            name="kcal"
            placeholder={placeholder}
            value={kcal}
            // hint: validate gets the value from valueParser and validates it then
            validate={{ number: true }}
            valueParser={(value) => {
              const parsedNumber = parseInt(parseLocaleNumber(value, locale));
              return parsedNumber >= 0 ? parsedNumber : {}; // {} is definitely not a number
            }}
            {...props}
          />
        )}
      </FormattedMessage>
      <Label for={object?.id}>
        <FormattedMessage id="kcalLabel" />
      </Label>
      <InputGroupAddon addonType="append">kcal</InputGroupAddon>
    </AvGroup>
  );
};

KcalField.propTypes = {
  object: PropTypes.object,
};

export default KcalField;
